// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import React, { ReactNode } from "react";

/**
 * You can pass JSX component to replacer
 * {xTranslate("{0} example", <Link href="/order">Order</Link>)}
 *
 * https://xngage.atlassian.net/browse/XSPIRE-682
 */
export const xTranslate = (text: string, ...values: (ReactNode | string | number)[]): JSX.Element | string | null => {
    if (!text) {
        return "";
    }

    const isStringOnly = values.every(value => typeof value === "string");
    if (isStringOnly) {
        return translate(text, ...(values as readonly string[]));
    }

    const message = translate(text);
    if (values.length === 0) {
        return message;
    }

    const parts = message.split(/\{\d+}/);
    const result: JSX.Element[] = [];

    parts.forEach((part, index) => {
        result.push(<React.Fragment key={part}>{part}</React.Fragment>);
        const value = values[index];
        if (value !== undefined) {
            const element = React.isValidElement(value) ? (
                value
            ) : (
                <React.Fragment key={`${part}_${index}_value`}>{value}</React.Fragment>
            );
            result.push(element);
        }
    });

    return <>{result}</>;
};
